<template>
  <div class="container">
    <div>
      <el-form
        inline
        size="mini"
        label-width="45px"
        class="table-search-part"
        @submit.native.prevent="handleQuery()"
      >
        <div>
          <el-form-item label="User ID">
            <el-input
              clearable
              type="number"
              v-model="
              queryData.userId"
              placeholder="User ID"
            ></el-input>
          </el-form-item>
          <el-form-item label="IP">
            <el-input class="last-input" clearable v-model.trim="queryData.ip" placeholder="IP"></el-input>
          </el-form-item>
          <el-form-item label="Match ID">
            <el-input
              type="number"
              class="last-input"
              clearable
              v-model="queryData.matchId"
              placeholder="Match ID"
            ></el-input>
          </el-form-item>
          <el-form-item label="Stake>=">
            <el-input
              type="number"
              class="last-input"
              clearable
              v-model="queryData.minStake"
              placeholder="Stake"
            ></el-input>
          </el-form-item>

          <el-button class="search-btn" @click="handleQuery()">Search</el-button>
        </div>
      </el-form>
    </div>
    <div class="syslog-table">
      <el-table
        ref="table"
        :data="list"
        :height="tableHeight"
        stripe
        v-loading="loading"
        header-row-class-name="table-header-row"
        border
      >
        <template slot="empty">
          <Empty />
        </template>
        <el-table-column type="index" label="Number" width="70" align="center"></el-table-column>
        <el-table-column prop="ip" label="Betting IP" min-width="112">
          <template v-slot="{ row }">
            <div :class="{ 're-ip-name': row.isObserved }">{{ row.ip }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="matchId" label="Match ID" min-width="112"></el-table-column>
        <el-table-column label="Order Time" min-width="245">
          <template v-slot="{ row }">
            <div v-if="row.firstTime">{{ formatUtc(row.firstTime) }}-{{ formatUtc(row.lastTime) }}</div>
          </template>
        </el-table-column>
        <el-table-column label="User ID" prop="userIds" min-width="285">
          <template v-slot="{ row }">
            <span v-for="item in row.userIds" :key="item" class="userId-item">
              <el-link :underline="false" class="table-inner-text-btn">{{ item }}</el-link>
            </span>
          </template>
        </el-table-column>
        <el-table-column label="Bets" prop="bets" min-width="70" align="center"></el-table-column>
        <el-table-column label="Stake" prop="stake" min-width="70" align="center">
          <template v-slot="{ row }">
            <div v-if="Number(row.stake)">{{ Number(row.stake).toFixed(0) }}</div>
          </template>
        </el-table-column>
        <el-table-column label="Region" prop="region" min-width="200"></el-table-column>
        <el-table-column label="Operation" min-width="140">
          <template v-slot="{ row }">
            <div>
              <el-button
                class="table-inner-btn view-order-btn"
                @click="sendToElectronPage(row)"
              >View Order</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="pagination-wrapper inline-wrapper">
      <el-pagination
        class="inline-right"
        :total="total"
        :current-page="queryData.current"
        :page-size="queryData.size"
        :page-sizes="[50, 100, 200]"
        @current-change="changePage"
        @size-change="handleSizeChange"
        layout="total, sizes, prev, pager, next, jumper"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Empty from "@/components/empty/index";
import { getIPList } from "@/api/ip";
//const { ipcRenderer } = require("electron");
export default {
  name: "IPList",
  data() {
    return {
      list: [],
      total: 0,
      loading: false,
      queryData: {
        current: 1,
        size: 50,
        userId: "",
        matchId: "",
        minStake: "",
        ip: ""
      },
      showOverflow: false,
      tableHeight: window.innerHeight
    };
  },
  methods: {
    async getList() {
      if (this.queryData.ip) {
        const reg = /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/;
        if (!reg.test(this.queryData.ip)) {
          this.$message({
            message: "Incorrect IP format",
            type: "warning"
          });
          return false;
        }
      }
      this.loading = true;
      try {
        const res = await getIPList(this.queryData);
        if (res.data) {
          const data = res.data || {};
          this.list = data.records || [];
          this.total = data.total;
        } else {
          this.$message({ message: res.message, type: "warning" });
        }
        this.loading = false;
      } catch (error) {
        this.list = [];
        this.loading = false;
      }
    },
    // 搜索
    handleQuery() {
      this.queryData.current = 1;
      this.getList();
    },
    // 清除搜索
    handleClearQuery() {
      this.handleClear();
      this.getList();
    },
    // 分页
    changePage(e) {
      this.queryData.current = e;
      this.getList();
    },
    // 列表显示条目
    handleSizeChange(e) {
      this.queryData.size = e;
      this.queryData.current = 1;
      this.getList();
    },
    // utc时间
    formatUtc(time) {
      if(!time) return "";
      return this.$moment(+time).format("YYYY-MM-DD HH:mm:ss");
    },
    // electron通讯方法(向客户端发送消息)
    sendToElectronPage(params) {
      if (window.require("electron")) {
        let ipcRenderer = window.require("electron").ipcRenderer;
        ipcRenderer.send(
          "createWindow",
          "order-management",
          `matchId=${params.matchId}&ip=${params.ip}&betType=0`
        );
      }
    }
  },
  components: {
    Empty
  },
  mounted() {
    this.getList();
    this.$nextTick(() => {
      let self = this;
      self.tableHeight =
        window.innerHeight - self.$refs.table.$el.offsetTop - 94;
      window.onresize = function() {
        self.tableHeight =
          window.innerHeight - self.$refs.table.$el.offsetTop - 94;
      };
    });
  }
};
</script>

<style lang="scss" scoped>
.table-search-part {
  padding: 0;
  .el-form-item--mini.el-form-item {
    margin-bottom: 18px;
  }
}
.last-input {
  margin: 0 20px 0 0 !important;
}
.re-ip-name {
  color: #e1554f;
}
.userId-item::after {
  display: inline-block;
  content: ",";
}
.userId-item:last-child {
  &::after {
    display: none;
  }
}
/deep/.el-form-item__label {
  width: 60px !important;
}
</style>
